// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  elementProps: PropTypes.object
};

MarkdownComponent.defaultProps = {
  elementProps: {}
};

MarkdownComponent['title'] = 'Windows';

function MarkdownComponent(props) {
  const { className, style, elementProps } = props;

  return (
    <div className={className} style={style}>
      <ol {...elementProps['ol']}>
      <li {...elementProps['li']}>Download the latest Windows beta from <a href="https://github.com/buildkite/agent/releases" {...elementProps['a']}>Buildkite Agent releases on GitHub</a></li>
      <li {...elementProps['li']}>Extract the files to a directory of your choice</li>
      <li {...elementProps['li']}>Edit <code {...elementProps['code']}>buildkite-agent.cfg</code> and add your token</li>
      <li {...elementProps['li']}>Run <code {...elementProps['code']}>buildkite-agent start</code> from a command prompt</li>
      </ol>
      <p className="rounded bg-silver p2" {...elementProps['p']}>See the <a href="/docs/agent/windows" {...elementProps['a']}>Windows agent docs</a> for more details.</p>
      <p {...elementProps['p']}>When asked, enter your agent token:</p>
      <pre {...elementProps['pre']}><code className="language-markdown" {...elementProps['code']}>{ props.token || 'INSERT-YOUR-AGENT-TOKEN-HERE' }<br {...elementProps['br']} /></code></pre>
    </div>
  );
};

export default MarkdownComponent;
